<app-ip-list
  [domainName]="site().domainName"
  [ipListService]="blacklistedIpsService()"
  titleKey="BlacklistedIps.title"
  descriptionKey="BlacklistedIps.description"
  noneLabel="BlacklistedIps.none"
/>
<hr />
<app-ip-list
  [domainName]="site().domainName"
  [ipListService]="whitelistedIpsService()"
  titleKey="WhitelistedIps.title"
  descriptionKey="WhitelistedIps.description"
  noneLabel="WhitelistedIps.none"
/>
<hr />
<div *featureFlag="'siteTrustedIps'">
  <app-ip-list
    [domainName]="site().domainName"
    [ipListService]="trustedIpsService()"
    titleKey="TrustedIps.title"
    descriptionKey="TrustedIps.description"
    noneLabel="TrustedIps.none"
  />
  <hr />
</div>

<div>
  <div>
    <h5>{{ 'UrlExceptions.title' | translate }}</h5>
    <p class="description" innerHTML="{{ 'UrlExceptions.description' | translate }}"></p>
  </div>
  <div class="table-responsive mysite-details">
    <table class="table mysite-details">
      <thead>
        <tr>
          <th [ngStyle]="{ width: '25rem' }">
            {{ 'URL' | translate }}&nbsp;
            <a [href]="'ExternalHelp.regex' | translate" class="ogo-link" target="_blank">
              ({{ 'RegexpGuide' | translate }}<i class="icofont icofont-external-link ml-1"></i>)
            </a>
          </th>
          <th>
            {{ 'Comments' | translate }}
          </th>
          <th [ngStyle]="{ width: '8rem' }">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (urlException of urlExceptions; track urlException.id) {
          <tr>
            <td class="py-auto">
              <span *ngIf="urlException.id && !urlException.editing">{{ urlException.path }}</span>
              <input
                class="form-control form-control-sm"
                [class.is-invalid]="isInvalidPath"
                #urlExceptionElement
                (keyup)="checkPath($event.target.value)"
                (keydown)="handleEnterUrlException($event, urlException)"
                *ngIf="!urlException.id || urlException.editing"
                [(ngModel)]="urlException.path"
                style="width: 350px; height: 33px"
              />
              @if (isInvalidPath) {
                <small class="text-danger">{{ 'IncorrectPath' | translate }}</small>
              }
            </td>
            <td>
              <span *ngIf="urlException.id && !urlException.editing" [title]="urlException.comment">
                {{ urlException.comment }}
              </span>
              <textarea
                (keydown)="handleEnterUrlException($event, urlException)"
                *ngIf="!urlException.id || urlException.editing"
                [(ngModel)]="urlException.comment"
                maxlength="255"
                placeholder="{{ 'CommentsOptional' | translate }}"
                style="height: 100%; width: 100%; border: 1px solid #dfdfdf; border-radius: 2px"
              ></textarea>
            </td>
            <td>
              <button
                (click)="
                  !isEditingUrlException() && !isCreatingUrlException() && startUrlExceptionEditing(urlException)
                "
                *ngIf="!urlException.editing && urlException.id"
                [ngStyle]="{
                  color: isEditingUrlException() || isCreatingUrlException() ? '#dbd9da' : '#4099ff',
                  cursor: isEditingUrlException() || isCreatingUrlException() ? 'default' : 'pointer',
                }"
                disableOnClick
                [reEnableButton]="isLoading"
                class="pointer btn btn-transparent p-1 icofont icofont-edit-alt"
                style="font-size: 19px; position: relative; top: 1px"
                title="{{ 'Modifier' | translate }}"
              ></button>
              <button
                (click)="validateUrlExceptionEditing(urlException)"
                *ngIf="urlException.editing"
                [ngStyle]="{
                  color: urlException.path.length == 0 ? '#dbd9da' : '#4099ff',
                  cursor: urlException.path.length == 0 ? 'default' : 'pointer',
                }"
                class="pointer btn btn-transparent p-1 icofont icofont-check"
                disableOnClick
                [reEnableButton]="isLoading"
                style="font-size: 27px"
                title="{{ 'Validate' | translate }}"
              ></button>
              <button
                (click)="deleteUrlException(urlException)"
                *ngIf="urlException.editing"
                class="pointer btn btn-transparent p-1 icofont icofont-close"
                style="color: #e74c3c; font-size: 22px; top: -1px"
                title="{{ 'Annuler' | translate }}"
              ></button>
              <button
                (click)="deleteUrlException(urlException)"
                *ngIf="urlException.id && !urlException.editing"
                class="pointer btn btn-transparent p-1 icofont icofont-ui-delete"
                style="color: #e74c3c; font-size: 19px; top: -1px"
                title="{{ 'supprimer' | translate }}"
              ></button>
              <button
                (click)="urlException.path.length && createUrlException(urlException)"
                *ngIf="!urlException.id"
                [ngStyle]="{
                  color: urlException.path.length ? '#4099ff' : '#dbd9da',
                  cursor: urlException.path.length ? 'pointer' : 'default',
                }"
                [reEnableButton]="isLoading"
                class="pointer btn btn-transparent p-1 icofont icofont-check"
                disableOnClick
                style="font-size: 27px"
                title="{{ 'ajouter' | translate }}"
              ></button>
              <button
                (click)="deleteUrlException(urlException)"
                *ngIf="!urlException.id"
                class="pointer btn btn-transparent p-1 icofont icofont-close"
                style="color: #e74c3c; font-size: 24px"
                title="{{ 'Annuler' | translate }}"
              ></button>
            </td>
          </tr>
        }
        @if (!urlExceptions.length) {
          <tr>
            <td class="text-center" colspan="3">{{ 'NoUrlExceptions' | translate }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (!isCreatingUrlException() && !isEditingUrlException()) {
    <div class="container-fluid mt-3">
      <a class="ogo-link" (click)="addUrlException()">+ {{ 'UrlExceptions.addLabel' | translate }}</a>
    </div>
  }
</div>
